"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsEditorRow = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
const QueryEditor_1 = require("../../QueryEditor");
function OperationsEditorRow({ children }) {
    const styles = (0, ui_1.useStyles2)(getStyles);
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(QueryEditor_1.EditorStack, { gap: 1 }, children)));
}
exports.OperationsEditorRow = OperationsEditorRow;
const getStyles = (theme) => {
    return {
        root: (0, css_1.css)({
            padding: theme.spacing(1, 1, 0, 1),
            backgroundColor: theme.colors.background.secondary,
            borderRadius: theme.shape.radius.default,
        }),
    };
};
//# sourceMappingURL=OperationsEditorRow.js.map